module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new-desktop/0125.jpg?v=4c3f88a9";